import React from 'react'
import './confirmation.css'
import { HiCheckCircle } from "react-icons/hi2";
import Header from '../components/shared/header'
import Button from '../components/basic/button';

const Confirmation = () => {
    return (
        <div className="screen-main">

            <Header leftIcon="" label="Agenda" rightIcon="bell" action="/professionals" />

            <div class="confirmation-content">
                <div class="confirmation-icon">
                    ✓
                </div>
                <span className='app-title'>Tudo certo!</span>
                <span className='app-sub-title'>Seu horário está reservado.</span>
            </div>

            <div className='continue-button'>
                <Button Style='primary-color ' Label='Voltar ao início' Icon='calendar' Action='/establishment' Direction='Previous' />
                <Button Style='white-color ' Label='Novo agendamento' Icon='calendar' Action='/services' Direction='Previous' />
                <Button Style='white-color ' Label='Sair do app' Icon='calendar' Action='/establishment' Direction='Previous' />
            </div>
        </div>
    )
}


export default Confirmation

